/**
 * RK Gift Card Collection JavaScript
 * Handles interactions and animations
 */

(function() {
  'use strict';

  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    const wrapper = document.querySelector('.rk-collection-wrapper');
    if (!wrapper) return;

    // Initialize components
    initSmoothScroll();
    initScrollAnimations();
    initCardTracking();
  }

  /**
   * Smooth Scroll for anchor links
   */
  function initSmoothScroll() {
    const scrollLinks = document.querySelectorAll('a.smooth-scroll, a[href^="#"]');
    
    scrollLinks.forEach(link => {
      link.addEventListener('click', function(e) {
        const href = this.getAttribute('href');
        
        if (href && href.startsWith('#') && href !== '#') {
          e.preventDefault();
          const target = document.querySelector(href);
          
          if (target) {
            const offsetTop = target.getBoundingClientRect().top + window.pageYOffset - 80;
            
            window.scrollTo({
              top: offsetTop,
              behavior: 'smooth'
            });
          }
        }
      });
    });
  }

  /**
   * Scroll Animations - Fade in elements on scroll
   */
  function initScrollAnimations() {
    if (!('IntersectionObserver' in window)) return;

    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          observer.unobserve(entry.target);
        }
      });
    }, observerOptions);

    // Observe benefit cards and FAQ items
    const animatedElements = document.querySelectorAll(
      '.rk-benefit-card, .rk-faq-item, .rk-trust-item'
    );

    animatedElements.forEach((element, index) => {
      element.style.opacity = '0';
      element.style.transform = 'translateY(30px)';
      element.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      element.style.transitionDelay = `${index * 0.1}s`;
      observer.observe(element);
    });
  }

  /**
   * Track card clicks for analytics (optional)
   */
  function initCardTracking() {
    const productCards = document.querySelectorAll('.rk-product-card');
    
    productCards.forEach(card => {
      const cta = card.querySelector('.rk-card-cta');
      
      if (cta) {
        cta.addEventListener('click', function(e) {
          const productValue = card.getAttribute('data-product');
          
          // Track the click (you can integrate with your analytics)
          console.log(`Gift card clicked: ${productValue}€`);
          
          // You can add Google Analytics or other tracking here
          if (window.gtag) {
            window.gtag('event', 'select_promotion', {
              promotion_name: `Gift Card ${productValue}€`,
              creative_slot: 'collection_page'
            });
          }
        });
      }

      // Add hover effect enhancement
      card.addEventListener('mouseenter', function() {
        this.style.transition = 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)';
      });
    });
  }

  /**
   * Add sticky CTA on scroll (optional enhancement)
   */
  function initStickyCTA() {
    const heroSection = document.querySelector('.rk-collection-hero');
    const productsSection = document.querySelector('.rk-products-section');
    
    if (!heroSection || !productsSection) return;

    let stickyBar = document.querySelector('.rk-sticky-cta');
    
    // Create sticky bar if it doesn't exist
    if (!stickyBar) {
      stickyBar = document.createElement('div');
      stickyBar.className = 'rk-sticky-cta';
      stickyBar.innerHTML = `
        <div class="rk-sticky-content">
          <div class="rk-sticky-text">
            <strong>Bis zu 50€ sparen</strong>
            <span>Zeitlich begrenzte Aktion</span>
          </div>
          <a href="#gutscheine" class="rk-sticky-button smooth-scroll">
            Gutschein wählen
          </a>
        </div>
      `;
      document.body.appendChild(stickyBar);

      // Add styles
      const styles = document.createElement('style');
      styles.textContent = `
        .rk-sticky-cta {
          position: fixed;
          bottom: 0;
          left: 0;
          right: 0;
          background: white;
          box-shadow: 0 -4px 16px rgba(0, 0, 0, 0.1);
          padding: 16px 20px;
          z-index: 1000;
          transform: translateY(100%);
          transition: transform 0.3s ease;
        }
        .rk-sticky-cta.visible {
          transform: translateY(0);
        }
        .rk-sticky-content {
          max-width: 1400px;
          margin: 0 auto;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 20px;
        }
        .rk-sticky-text {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        .rk-sticky-text strong {
          font-size: 16px;
          color: var(--rk-text-primary);
        }
        .rk-sticky-text span {
          font-size: 14px;
          color: var(--rk-text-secondary);
        }
        .rk-sticky-button {
          padding: 12px 28px;
          background: linear-gradient(135deg, var(--rk-action) 0%, var(--rk-action-dark) 100%);
          color: white;
          border-radius: 50px;
          font-weight: 700;
          text-decoration: none;
          white-space: nowrap;
        }
        @media (max-width: 768px) {
          .rk-sticky-content {
            flex-direction: column;
            text-align: center;
          }
        }
      `;
      document.head.appendChild(styles);
    }

    // Show/hide on scroll
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('visible');
          } else {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            const heroBottom = heroSection.offsetTop + heroSection.offsetHeight;
            
            if (scrollTop > heroBottom) {
              stickyBar.classList.add('visible');
            }
          }
        });
      },
      { threshold: 0.1 }
    );

    observer.observe(productsSection);
  }

  /**
   * Add countdown timer (optional)
   */
  function initCountdownTimer() {
    const urgencyBadge = document.querySelector('.rk-urgency-badge span');
    
    if (!urgencyBadge) return;

    // Set end date (e.g., 7 days from now)
    const endDate = new Date();
    endDate.setDate(endDate.getDate() + 7);

    function updateCountdown() {
      const now = new Date();
      const diff = endDate - now;

      if (diff <= 0) {
        urgencyBadge.textContent = 'Aktion beendet!';
        return;
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));

      if (days > 0) {
        urgencyBadge.textContent = `Noch ${days} Tag${days > 1 ? 'e' : ''} verfügbar!`;
      } else {
        urgencyBadge.textContent = `Noch ${hours}h ${minutes}m verfügbar!`;
      }
    }

    // Uncomment to enable countdown
    // updateCountdown();
    // setInterval(updateCountdown, 60000); // Update every minute
  }

  // Optional: Initialize sticky CTA (uncomment if needed)
  // initStickyCTA();

  // Optional: Initialize countdown (uncomment if needed)
  // initCountdownTimer();

})();